import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../shared';
import { Session } from '../../services/session.service';
import { LogoResults } from '../../models/LogoResults';

@Component({
    selector: 'app-logos',
    template: `
    @if (logoData) {
      <div>
        @if (logoData.clientLogoImg) {
          <img
            src="data:image/JPEG;base64,{{ logoData.clientLogoImg }}"
            class="tw-w-full tw-h-full tw-object-contain"
            alt="{{ 'ClientLogoAlt' | translationClientCustomization:logoData.clientLogoAlt }}"
            tabindex="0"
            [attr.aria-label]="'ClientLogoAlt' | translationClientCustomization:logoData.clientLogoAlt"
            />
          }
        </div>
      }
    `,
    standalone: false
})
export class LogosComponent extends BaseComponent implements OnInit {
  logoData: LogoResults;
  constructor(public session: Session) {
    super();
  }
  async ngOnInit() {
    this.logoData = await this.session.GetLogoDetails();
  }
}
